import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import { ACTION_NEEDED, ACTIVATION, EMAIL_SIGNATURE, FETCH, KEYS, PASSWORD, UPDATE, USER, SMS_VERIFICATION, PHONE_VERIFICATION, SEND, RESEND, CONFIRM, STATUS } from "../queryKeys";
import { profileApi } from "src/services/settings/profile";
import { useDispatch } from "react-redux";
import { updatingUserProfileFailed, updatingUserProfileSucceeded } from "src/redux/actions/users";


export const useUserFetch = () => {
  return useQueryBuilder([USER, FETCH], profileApi.fetchUser);
};

export const useUserUpdate = () => {
  const dispatch = useDispatch();
  const mutation = useMutationBuilder([USER, UPDATE], profileApi.updateUser, [USER, FETCH]);

  return {
    ...mutation,
    mutate: (data: any) => {
      mutation.mutate(data, {
        onSuccess: (updatedUser) => {
          // Update Redux state with the response
          dispatch(updatingUserProfileSucceeded(updatedUser));
        },
        onError: (error) => {
          dispatch(updatingUserProfileFailed(error));
        }
      });
    }
  };
}

export const usePasswordUpdate = () => {
  return useMutationBuilder([PASSWORD, UPDATE], profileApi.updatePassword);
}

export const useEmailSignatureUpdate = () => {
  return useMutationBuilder([EMAIL_SIGNATURE, UPDATE], profileApi.updateEmailSignature, [USER, FETCH]);
}

export const useCapabilitiesActionNeededFetch = () => {
  return useQueryBuilder([USER, ACTION_NEEDED ], profileApi.fetchCapabilitiesActionNeeded);
}

export const useActivatedKeysFetch = () => {
    return useQueryBuilder([USER, ACTIVATION, KEYS], profileApi.fetchActivatedKeys);
}

export const useSmsVerificationSend = () => {
  return useMutationBuilder([SMS_VERIFICATION, SEND], profileApi.sendSmsVerification, [PHONE_VERIFICATION]);
}

export const useSmsVerificationResend = () => {
  return useMutationBuilder([SMS_VERIFICATION, RESEND], profileApi.resendSmsVerification, [PHONE_VERIFICATION]);
}

export const useSmsVerificationConfirm = () => {
  return useMutationBuilder([SMS_VERIFICATION, CONFIRM], profileApi.confirmSmsVerification, [USER, FETCH]);
}

export const usePhoneVerificationStatus = () => {
  return useQueryBuilder(
    [PHONE_VERIFICATION, STATUS],
    profileApi.getPhoneVerificationStatus,
    false,           // refetchOnWindowFocus
    5 * 1000,        // staleTime - reduced to 5 seconds for fresher data
    false            // refetchOnMount
  );
}
